import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bab56e02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loggedin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/logout" }, "Logout", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_license_screen = _resolveComponent("license-screen")!
  const _component_details_screen = _resolveComponent("details-screen")!
  const _component_billing_screen = _resolveComponent("billing-screen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(" Logged in as: " + _toDisplayString(_ctx.user.email) + " | ", 1),
      _hoisted_2
    ]),
    (_ctx.screen === 'license')
      ? (_openBlock(), _createBlock(_component_license_screen, {
          key: 0,
          onLicenseSelected: _ctx.setLicense
        }, null, 8, ["onLicenseSelected"]))
      : _createCommentVNode("", true),
    (_ctx.screen === 'details')
      ? (_openBlock(), _createBlock(_component_details_screen, {
          key: 1,
          user: _ctx.user,
          onDetailsSet: _ctx.setDetails
        }, null, 8, ["user", "onDetailsSet"]))
      : _createCommentVNode("", true),
    (_ctx.screen === 'billing')
      ? (_openBlock(), _createBlock(_component_billing_screen, {
          key: 2,
          intent: _ctx.intent,
          license: _ctx.license
        }, null, 8, ["intent", "license"]))
      : _createCommentVNode("", true)
  ], 64))
}